module.exports = __webpack_public_path__ + "img/phone-02.97bd21ad.svg";